import { render, staticRenderFns } from "./Paginacao.vue?vue&type=template&id=ce6ed204"
import script from "./Paginacao.vue?vue&type=script&lang=js"
export * from "./Paginacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports